import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Client-side route changes don't scroll like real navigation does — the
 * browser only auto-scrolls to a `#hash` on a hard page load. This restores
 * that behavior for React Router: scroll to the hash target on the home
 * page's anchor sections, or reset to the top on a plain page change (e.g.
 * navigating into /blog or between articles).
 */
export function HashScroll() {
  const { pathname, hash, key } = useLocation()

  // `key` changes on every navigation, so clicking a nav link whose #hash is
  // already in the URL (e.g. you scrolled away from #faq and click "FAQ" again)
  // still scrolls. With only [pathname, hash] as deps that click did nothing.
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1))
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        return
      }
    }
    window.scrollTo({ top: 0 })
  }, [pathname, hash, key])

  return null
}
